// export const PATH_URL =  "http://172.16.0.194:17031/"

export const PATH_URL =  "https://ondemantruck-api.devtechnosys.tech/";
export const API_BASE = PATH_URL+"api/v1/admin/auth"
export const API_BASE1= PATH_URL+"api/v1/admin"
export const IMAGE_BASE = PATH_URL
export const SOCKET_URL =  PATH_URL

// export const API_BASE = "https://ticketdash-api.devtechnosys.tech/api/v1/admin";
// export const IMAGE_BASE = "https://ticketdash-api.devtechnosys.tech/";
export const BASE_API = API_BASE + "/api";
export const MAIN_URL = BASE_API + "/api/admin";
export const MOBILE_REGEX = /^[0-9]{10}$/;

// export const PASSWORDS_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$@!%^&*?])[A-Za-z\d#$@!%^&*?]{8,}$/;
export const PASSWORDS_REGEX = /^(?=\S{8,})(?=\S)(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\p{L}\p{N}\s]).*$/u;

export const EMAIL_REGEX =
  /^(?![.+-])([a-zA-Z0-9._+-]+)(?!\.)[a-zA-Z0-9]+@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}))$/;
  
export const NOSPACE_REGEX = /^[^\s]+(\s+[^\s]+)*$/;
export const  NAME_CITY_REGEX = /^[a-zA-Z\s\-']+$/;
export const ADDRESS_REGEX = /^[a-zA-Z0-9\s,'\-\/\.#]+$/;


export const REMOVENBSP = /&nbsp;/g
export const NOSPACE = "Spaces are not allowed";

export const SUPPORTED_FORMATS = [
  "image/jpg",
  "image/jpeg",
  "image/png",
  "image/gif",
  "video/mp4",
  "video/x-ms-wmv",
  "video/quicktime",
  "video/webm",
  "application/pdf",
  "text/plain",
  "application/msword",
  "application/vnd.ms-excel",
  "application/vnd.ms-powerpoint",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
];

export const MULTIPLESPACE = /  +/g;

export const CARD_REGEX =
  /^(?:4[0-9]{12}(?:[0-9]{3})?|[25][1-7][0-9]{14}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11})$/g;

export const NODIGITREGEX = /^([^0-9]*)$/;

export const DECIMALPATTERN = /^[0-9]+(\.[0-9]{1,2})?$/;

export const REMOVEHTML = /(<([^>]+)>)/gi;

export const GENDER_OPTIONS = [
  { value: "Male", label: "Male" },
  { value: "Female", label: "Female" },
  { value: "Prefer not to say", label: "Prefer not to say" },
];

export const STATUS_OPTIONS = [
  { value: false, label: "Active" },
  { value: true, label: "Inactive" },
];

export const ADS_TYPE_OPTIONS = [
  { value: "daily", label: "Daily" },
  { value: "weekly", label: "Weekly" },
];

export const STATUS_OPTIONS_LIST = [
  { value: "active", label: "Active" },
  { value: "inactive", label: "Inactive" },
  {value:"pending", label: "Pending"},
  {value:"approved", label: "Approved"},
  { value: "rejected", label: "Rejected" },
];

export const AUCTION_STATUS_OPTIONS_LIST = [
  { value: "live", label: "Live" },
  { value: "upComming", label: "Upcoming" },
  { value: "expired", label: "Expired" },
  { value: "completed", label: "Completed" },
];

export const Verification_OPTIONS = [
  { value: "pending", label: "Pending" },
  { value: "cancelled", label: "Cancelled" },
];
export const PLAN_OPTIONS = [
  { value: true, label: "Active" },
  { value: false, label: "Inactive" },
];

export const SUPPORT_OPTIONS_LIST = [
  { value: "resolved", label: "Resolved" },
  { value: "pending", label: "Pending" },
  { value: "inProgress", label: "In Progress" },
];

export const Role_OPTIONS_LIST = [
  { value: "guest", label: "Guest" },
  { value: "user",  label: "User" },
];
export const styledClass = (type) => {
  switch (type) {
    case "edit":
      return {
        color: "#6a1b9a",
        border: "1px solid rgb(12, 12, 12)",
        borderRadius: 1,
        padding: "6px !important",
      };
    case "delete":
      return {
        color: "#6a1b9a",
        border: "1px solid rgb(13, 13, 14)",
        borderRadius: 1,
        padding: "7px !important",
      };
    case "view":
      return {
        color: "#6a1b9a",
        border: "1px solid rgb(12, 12, 12)",
        borderRadius: 1,
      };
    case "block":
      return {
        color: "red",
        border: "1px solid red",
        borderRadius: 1,
        padding: "7px !important",
      };
    case "unblock":
      return {
        color: "green",
        border: "1px solid green",
        borderRadius: 1,
        padding: "7px !important",  
      };
    case "viewIcon":
      return {
        color: "#6a1b9a",
        border: "1px solid rgb(12, 12, 12)",
        borderRadius: 1,
      };
    case "lockIcon":
      return {
        color: "red",
        border: "1px solid red",
        borderRadius: 1,
        padding: "7px !important",
      };
    case "unlockIcon":
      return {
        color: "green",
        border: "1px solid green",
        borderRadius: 1,
        padding: "7px !important",
      };
    case "deleteIcon":
      return {
        color: "#6a1b9a",
        border: "1px solid rgb(13, 13, 14)",
        borderRadius: 1,
        padding: "7px !important",
      };
    case "viewButton":
      return {
        color: "#6a1b9a",
        border: "1px solid rgb(12, 12, 12)",
        borderRadius: 1,
      };
    default:
      return {};
  }
};